export const DEFAULT_SPACING = { rank: 64, sibling: 16, subtree: 28 };
export function spacingFrom(spacing) {
    return { ...DEFAULT_SPACING, ...spacing };
}
export const NO_CHANGES = { positions: {} };
export function hasChanges(result) {
    return Object.keys(result.positions).length > 0;
}
//# sourceMappingURL=types.js.map